import React, { useState, useContext, useEffect } from "react";
import { IonHeader, IonTitle, IonToolbar, IonButtons, IonButton } from '@ionic/react';
import { Pane, SelectField, Button, FilterRemoveIcon, Option } from 'evergreen-ui';
import { globalContext } from '../../global/Store';
import { MainFilterComponentStyle } from "./FilterComponentStyle";
//import {MainFilterComponentStyle} from "./FilterComponentStyle";

const FilterComponent = (props: any) => {

  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const [developmentFilter, setDevelopmentFilter] = useState('All');
  const [statusFilter, setStatusFilter] = useState('All');

  useEffect(() => {
    console.log("Filter reloaded");
    handleClearFilter('clearFilter');
  }, [props.reloadComponent]);

  const handleDevelopmentsChange = (e: any) => {
    setDevelopmentFilter(e);
    sendCaseToParent(e, 'dev');
  }

  const handleStatusChange = (e: any) => {
    setStatusFilter(e);
    sendCaseToParent(e, 'status');
  }

  const handleClearFilter = (e: any) => {
    setDevelopmentFilter('All');
    setStatusFilter('All');
    sendCaseToParent(e, 'clearFilter');
  }

  const sendCaseToParent = (e: any, flg: string) => {
    props.sendCaseToParent(e, flg);
  }

  let developmentDropDown = globalState.developments
    .map((d: any, index: any) => {
      return (
        <option style={{ fontSize: '12px' }} key={index} value={d.id}>{d.name}</option>
      );
    });

  let statusDropDown = globalState.caseStatuses
    .filter((dropdown: any) => dropdown.lookupTypeId === 6)
    .sort((a: any, b: any) => a.description.localeCompare(b.description))
    .map((d: any, index: any) => {
      return (
        <option style={{ fontSize: '12px' }} key={index} value={d.id}>{d.description}</option>
      );
    });

  return (
      <Pane style={{ margin: "50px 50px -20px 50px", display: "flex" }}>

        <SelectField style={{ marginRight: '20px', width: '185px' }} label="Developments" value={developmentFilter} onChange={(e) => handleDevelopmentsChange(e.target.value)}>
          <option value="clearFilterAll" onChange={() => handleClearFilter('clearFilterAll')}>All</option>
          
          {developmentDropDown}
          <option value="0" >Staircasing</option>
        </SelectField>

        <SelectField style={{ marginRight: '20px', width: '185px' }} label="Status" value={statusFilter} onChange={(e) => handleStatusChange(e.target.value)}>
          <option value="clearFilterAll" onChange={() => handleClearFilter('clearFilterAll')}>All (not Closed)</option>
          {statusDropDown}
        </SelectField>

        <Pane paddingTop={25} paddingLeft={25}>
          <Button paddingLeft={35} marginRight={16} appearance="primary" intent="muted" style={{ background: 'rgb(152, 0, 83)', border: 'rgb(152, 0, 83)' }} 
          iconBefore={FilterRemoveIcon} width={150} onClick={() => handleClearFilter('clearFilter')}>
            Clear Filter
          </Button>
        </Pane>
      </Pane>
  );

}

export default FilterComponent;